import "zone.js";
import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from "@angular/core";
import { environment } from "@apps/patient-core/src/app/environments/environment";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";
import { CurrencyPipe } from "@angular/common";
import { PatientAppComponent } from "./app/app.component";
import { APP_ROUTES } from "./app/app.routing";
import { PatientAppInitService } from "./app/services/derived/app-init.service";
import * as PROVIDERS from "@apps/patient-core/generate-abstract-providers";
import { logger } from "@dentally/ui/logger";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(PatientAppComponent, {
  providers: [
    provideRouter(APP_ROUTES),
    ...PROVIDERS.PATIENT_HTTP_INTERCEPTORS,
    CurrencyPipe,
    ...PROVIDERS.PATIENT_PROVIDERS,
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const appInitService = inject(PatientAppInitService);
      return appInitService.init();
    }),
    importProvidersFrom(BrowserModule, BrowserAnimationsModule),
  ],
}).catch((err) => logger.error(err));
